module.exports = __webpack_public_path__ + "img/kravtsov.447ce0a2.jpg";